export const GENERATED_DOCUMENTS_PAGE = {
  GENERATED_DOCUMENTS_TITLE: {
    key: 'GENERATED_DOCUMENTS_TITLE',
    value: 'Clean Up Storage Space',
  },
  GENERATED_DOCUMENTS_DESCRIPTION: {
    key: 'GENERATED_DOCUMENTS_DESCRIPTION',
    value: 'Use the space to clean up your storage space and to get rid of unnecessary documents',
  },
  TEMPLATE_NAMES_LABEL: {
    key: 'TEMPLATE_NAMES_LABEL',
    value: 'Templates',
  },
  TEMPLATE_NAMES_PLACEHOLDER: {
    key: 'TEMPLATE_NAMES_PLACEHOLDER',
    value: 'Select templates to filter',
  },
  CHANNEL_TYPE_LABEL: {
    key: 'CHANNEL_TYPE_LABEL',
    value: 'Channel',
  },
  CHANNEL_TYPE_PLACEHOLDER: {
    key: 'CHANNEL_TYPE_PLACEHOLDER',
    value: 'Select Channel to filter',
  },  
  FILE_TYPE_LABEL: {
    key: 'FILE_TYPE_LABEL',
    value: 'File type',
  },  
  FILE_TYPE_PLACEHOLDER: {
    key: 'FILE_TYPE_PLACEHOLDER',
    value: 'Select file type to filter',
  }, 
  TEAM_NAMES_LABEL: {
    key: 'TEAM_NAMES_LABEL',
    value: 'Team',
  },
  TEAM_NAMES_PLACEHOLDER: {
    key: 'TEAM_NAMES_PLACEHOLDER',
    value: 'Select teams to filter',
  },
  FROM_DATE_LABEL: {
    key: 'FROM_DATE_LABEL',
    value: 'Generated From',
  },
  FROM_DATE_PLACEHOLDER: {
    key: 'FROM_DATE_PLACEHOLDER',
    value: 'Select start date',
  },
  TO_DATE_LABEL: {
    key: 'TO_DATE_LABEL',
    value: 'Generated Till',
  },
  TO_DATE_PLACEHOLDER: {
    key: 'TO_DATE_PLACEHOLDER',
    value: 'Select end date',
  },
  DELETE_ALL_BUTTON_LABEL: {
    key: 'DELETE_ALL_BUTTON_LABEL',
    value: 'Delete All',
  },
  SEARCH_BUTTON_LABEL: {
    key: 'SEARCH_BUTTON_LABEL',
    value: 'Search',
  },
  DOCUMENT_NAME_COLUMN_TITLE: {
    key: 'DOCUMENT_NAME_COLUMN_TITLE',
    value: 'Document Name',
  },
  ENVIRONMENT_COLUMN_TITLE: {
    key: 'ENVIRONMENT_COLUMN_TITLE',
    value: 'Environment',
  },
  ENVIRONMENT_COLUMN_TESTING_OPTION: {
    key: 'ENVIRONMENT_COLUMN_TESTING_OPTION',
    value: 'Testing',
  },
  ENVIRONMENT_COLUMN_PUBLISHED_OPTION: {
    key: 'ENVIRONMENT_COLUMN_PUBLISHED_OPTION',
    value: 'Published',
  },
  TEAM_COLUMN_TITLE: {
    key: 'TEAM_COLUMN_TITLE',
    value: 'Teams',
  },
  ACTION_COLUMN_TITLE: {
    key: 'ACTION_COLUMN_TITLE',
    value: 'Action',
  },
  VIEW_DOCUMENT_ACTION: {
    key: 'VIEW_DOCUMENT_ACTION',
    value: 'View',
  },
  DELETE_DOCUMENT_ACTION: {
    key: 'DELETE_DOCUMENT_ACTION',
    value: 'Delete',
  },
  DELETE_DOCUMENT_MODAL_TITLE: {
    key: 'DELETE_DOCUMENT_MODAL_TITLE',
    value: 'Delete Documents',
  },
  CANCEL_MODAL_BUTTON: {
    key: 'CANCEL_MODAL_BUTTON',
    value: 'Cancel',
  },
  STOREAGE_METRICS_HEADING: {
    key: 'STOREAGE_METRICS_HEADING',
    value: 'STORAGE',
  },
  USED_STORAGE_SPACE_TITLE: {
    key: 'USED_STORAGE_SPACE_TITLE',
    value: 'Storage space :',
  },
  USED_STORAGE_SPACE_VALUE_LABEL: {
    key: 'USED_STORAGE_SPACE_VALUE_LABEL',
    value: 'used out of',
  },
  DOCUMENTS_IN_STORAGE_TITLE: {
    key: 'DOCUMENTS_IN_STORAGE_TITLE',
    value: 'No of documents in storage :',
  },
  STORAGE_USAGE_PERCENTAGE_SUB_HEADING: {
    key: 'STORAGE_USAGE_PERCENTAGE_SUB_HEADING',
    value: 'Usage %',
  },
  DOCUMENTS_METRICS_HEADING: {
    key: 'DOCUMENTS_METRICS_HEADING',
    value: 'Documents',
  },
  DOCUMENTS_GENERATED_SUB_HEADING: {
    key: 'DOCUMENTS_GENERATED_SUB_HEADING',
    value: 'DOCUMENTS GENERATED',
  },
  STORAGE_METRICS_WARNING_MESSAGE: {
    key: 'STORAGE_METRICS_WARNING_MESSAGE',
    value:
      'NOTE: Any deleted files will remain in our database for 24 hours before being permanently removed. Only after this period will the correct storage usage be updated',
  },
  SELECTED_DOCUMNETS_COUNT_TITLE: {
    key: 'SELECTED_DOCUMNETS_COUNT_TITLE',
    value: 'Selected :',
  },
  DELETE_SELECTED_DOCUMNETS_ACTION: {
    key: 'DELETE_SELECTED_DOCUMNETS_ACTION',
    value: 'Delete Selected',
  },
  SEARCHED_DOCUMNETS_COUNT_TITLE: {
    key: 'SEARCHED_DOCUMNETS_COUNT_TITLE',
    value: 'Search results :',
  },
  SELECT_ALL_DOCUMETS_CHECKBOX: {
    key: 'SELECT_ALL_DOCUMETS_CHECKBOX',
    value: 'Select All',
  },
  ENVIRONMENT_FILTER_PLACEHOLDER: {
    key: 'ENVIRONMENT_FILTER_PLACEHOLDER',
    value: 'Select an environment',
  },
  ENVIRONMENT_LABEL: {
    key: 'ENVIRONMENT_LABEL',
    value: 'Environment',
  },
  SELECT_ALL_TEAMS_LABEL: {
    key: 'SELECT_ALL_TEAMS_LABEL',
    value: 'Select all teams',
  },
  SELECT_ALL_TEMPLATES_LABEL: {
    key: 'SELECT_ALL_TEMPLATES_LABEL',
    value: 'Select all templates',
  },
  CLEAR_DATE_FILTER_BUTTON: {
    key: 'CLEAR_DATE_FILTER_BUTTON',
    value: 'Clear Date',
  },
  CLEAR_ALL_FILTER_BUTTON: {
    key: 'CLEAR_ALL_FILTER_BUTTON',
    value: 'Clear All',
  },
  WRONG_GENERATED_FROM_DATE_ERROR_MESSAGE: {
    key: 'WRONG_GENERATED_FROM_DATE_ERROR_MESSAGE',
    value: 'Please make sure from date precedes Till date',
  },
  WRONG_GENERATED_TILL_DATE_ERROR_MESSAGE: {
    key: 'WRONG_GENERATED_TILL_DATE_ERROR_MESSAGE',
    value: 'Please make sure till date succeeds From date',
  },
  ENVIRONMENT_FILTER_TESTING_OPTION: {
    key: 'ENVIRONMENT_FILTER_TESTING_OPTION',
    value: 'Testing',
  },
  ENVIRONMENT_FILTER_PUBLISHED_OPTION: {
    key: 'ENVIRONMENT_FILTER_PUBLISHED_OPTION',
    value: 'Published',
  },
  ENVIRONMENT_FILTER_BOTH_OPTION: {
    key: 'ENVIRONMENT_FILTER_BOTH_OPTION',
    value: 'Both',
  },
  GENERATED_TILL_DATE_NOT_SELECTED_ERROR_MESSAGE: {
    key: 'GENERATED_TILL_DATE_NOT_SELECTED_ERROR_MESSAGE',
    value: 'Please pick a generated till date to fetch the documents',
  },
  GENERATED_FILE_DELETED_SUCCESS: {
    key: 'GENERATED_FILE_DELETED_SUCCESS',
    value: 'Generated file deleted successfully'
  },
  GENERATED_FILE_DELETED_FAILURE: {
    key: 'GENERATED_FILE_DELETED_FAILURE',
    value: 'An error occured while trying to delete generated file'
  }
};
export const CONFIRMATION_MODAL = {
  CONFIRMATION_MODAL_CANCEL_BUTTON: {
    key: 'CONFIRMATION_MODAL_CANCEL_BUTTON',
    value: 'Cancel',
  },
  CONFIRMATION_MODAL_DELETE_BUTTON: {
    key: 'CONFIRMATION_MODAL_DELETE_BUTTON',
    value: 'Delete',
  },
  CONFIRMATION_MODAL_FIRST_TEXT: {
    key: 'CONFIRMATION_MODAL_FIRST_TEXT',
    value: 'Are you sure you want to delete this document?',
  },
  CONFIRMATION_MODAL_SECOND_TEXT: {
    key: 'CONFIRMATION_MODAL_SECOND_TEXT',
    value: 'Are you sure you want to delete these',
  },
  CONFIRMATION_MODAL_THIRD_TEXT: {
    key: 'CONFIRMATION_MODAL_THIRD_TEXT',
    value: 'documents?',
  },
};